import { ClassTransformer } from 'class-transformer';
import { recursiveClean } from '../util';
function exposeUnsetFieldsIfNeeded(obj, exposeUnsetFields = true) {
    return exposeUnsetFields
        ? obj
        : recursiveClean(obj, {
            ignoreEmptyArrays: true,
            ignoreEmptyObject: true,
            ignoreNull: true,
            removeEmptyString: false,
        });
}
const classTransformer = new ClassTransformer();
export function instanceToInstanceWithLVS(object, options) {
    const method = 'instanceToInstance' in classTransformer ? classTransformer.instanceToInstance : classTransformer.classToClass;
    return method(object, options);
}
export function instanceToPlainWithLVS(object, options) {
    if ('instanceToPlain' in classTransformer) {
        return classTransformer.instanceToPlain(object, options);
    }
    return exposeUnsetFieldsIfNeeded(classTransformer.classToPlain(object, options), options?.exposeUnsetFields);
}
export function plainToInstanceWithLVS(cls, plain, options) {
    const method = 'plainToInstance' in classTransformer ? classTransformer.plainToInstance : classTransformer.plainToClass;
    return method(cls, plain, options);
}
//# sourceMappingURL=lvs.js.map